import { createApiInstance } from './handler';
import { LEADERSHIP_DEVELOPMENT, LEADERSHIP_MANAGER } from '../pages/reports/leader-reports';
import { CANDIDATE_DEVELOPMENT } from '../pages/reports/candidate-reports';

export const getReportTypeByToken = async (auth, token) => {
  try {
    const results = await createApiInstance(auth, 'enduser').get(`/reports-by-token/${token}`);
    const reportSlug = results.data.slug.toLowerCase();
    switch (reportSlug) {
      case 'leader-development':
        return LEADERSHIP_DEVELOPMENT;
      case 'leader-manager':
        return LEADERSHIP_MANAGER;
      case 'candidate-development':
        return CANDIDATE_DEVELOPMENT;
      default:
        return -1;
    }
  } catch (error) {
    console.error(error);
  }
};
